import {Button, Form, Input, InputNumber, Switch, Tag} from 'antd';
import {fieldRules} from 'utils/helper';
import {IconEditor} from './IconEditor';
import styles from './FlowBuilder.module.scss';

export const CategoryForm = ({form, mode, language, onFinish, submitting}) => {
  const isEdit = mode === 'edit';
  return (
    <div className={styles.formRoot}>
      <div className={styles.formHeader}>
        <h2>{isEdit ? 'Update Category' : 'Create Category'}</h2>
        <p className={styles.formContext}>
          Top-level category · <strong>{language}</strong>
        </p>
      </div>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item name="name" label="Name" rules={[fieldRules('Name')]}>
          <Input placeholder="e.g. Deposits & Withdrawals" />
        </Form.Item>
        <Form.Item name="iconUrl" label="Icon">
          <IconEditor />
        </Form.Item>
        <Form.Item
          name="sortOrder"
          label="Sort order"
          rules={[{type: 'number', min: 1, message: 'Must be at least 1'}]}>
          <InputNumber min={1} style={{width: '100%'}} />
        </Form.Item>
        <Form.Item name="isActive" label="Active" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item
          name="availableToAnonymous"
          label="Available to anonymous"
          valuePropName="checked"
          tooltip="Expose to logged-out users. A node only shows in the anonymous flow if it AND all its descendants you want reachable are flagged — cascade down Category → Feature → Issue.">
          <Switch />
        </Form.Item>
        <div className={styles.formActions}>
          <Tag color="blue">{language}</Tag>
          <Button type="primary" htmlType="submit" loading={submitting}>
            {isEdit ? 'Save Changes' : 'Create'}
          </Button>
        </div>
      </Form>
    </div>
  );
};
